import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { ChangeDetectorRef, Component, computed, ElementRef, inject, OnDestroy, OnInit, Signal, ViewChild } from '@angular/core';
import { APP_CONFIG } from '@configuration/configuration';
import { Configuration } from '@models/interfaces/configuration/index.interface';
import { DvmService } from '@services/dvm.service';
import anime from 'animejs';
import { skip, Subscription } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css',
})
export class LoaderComponent implements OnInit, OnDestroy {
  
  // VIEW CHILD
  @ViewChild('loader', { read: ElementRef })
  private  readonly loader!:  ElementRef<HTMLElement>;

  // SERVICES
  private  readonly config:       Signal<Configuration> = inject(APP_CONFIG);
  private  readonly viewer:       MapViewerService      = inject(DvmService).viewer; 
  private  readonly cdr:          ChangeDetectorRef     = inject(ChangeDetectorRef);

  // COMPONENT STATE
  protected          hideElement:   boolean         = true;
  protected readonly logo:          Signal<string>    = computed((): string => this.config().General.client.logo);
  private   readonly suscriptions:  Subscription[]  = [];

  // LIFECYCLE HOOKS
  ngOnInit(): void {
    this.initComponent();
  }

  ngOnDestroy(): void {
    this.destroyComponent();
  }

  // METHODS
  private toggleLoader(show: boolean): void {
    const loader: HTMLElement = this.loader.nativeElement;

    anime({
      begin:    (): void => { if(this.hideElement && show) this.hideElement = false },
      complete: (): void => { if(!show) this.hideElement = true; this.cdr.detectChanges() },
      targets:  loader,
      opacity:  show ? 1 : 0,
      easing:   'easeInOutQuad',
      duration: 500,
    })
  }

  private initComponent(): void {

    this.viewer.waitInitialize().subscribe((): void=> {      
      this.viewer.getObservable('start_load').pipe(skip(1)).subscribe((): void => this.toggleLoader(true));
      this.viewer.getObservable('load_success').pipe(skip(1)).subscribe((): void => this.toggleLoader(false));
      this.viewer.getObservable('load_error').subscribe((): void => this.toggleLoader(false));
    })

  }

  private destroyComponent(): void {
    this.suscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

}
